"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _InstaModal = require("./InstaModal");

var _InstaModal2 = _interopRequireDefault(_InstaModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialInsta = function SocialInsta(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalIsOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var year = void 0,
      month = void 0,
      day = void 0,
      time = void 0;
  if (props.post.timestamp) {
    year = props.post.timestamp.slice(0, 4);
    month = props.post.timestamp.slice(5, 7);
    day = props.post.timestamp.slice(8, 10);
    time = props.post.timestamp.slice(11, 16);
  }

  var handleOpenModal = function handleOpenModal() {
    setIsOpen(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setIsOpen(false);
    // window.location.reload(false);
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "div",
      { className: "post" },
      _react2.default.createElement(
        "div",
        { className: "post-container" },
        _react2.default.createElement(
          "div",
          { className: "post-header" },
          _react2.default.createElement(
            "div",
            { className: "tab" },
            _react2.default.createElement(
              "strong",
              null,
              props.post.username
            ),
            _react2.default.createElement(
              "p",
              { className: "post-date" },
              day + "/" + month + "/" + year + " at " + time
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "post-body" },
          props.post.caption && _react2.default.createElement(
            "p",
            { className: "post-body__title" },
            props.post.caption
          )
        )
      ),
      props.post.media_url && _react2.default.createElement(
        "div",
        { className: "post-image__container" },
        props.post.media_type === "IMAGE" && _react2.default.createElement("img", { className: "post-image", src: props.post.media_url }),
        props.post.media_type === "CAROUSEL_ALBUM" && props.post.children && _react2.default.createElement(
          "div",
          { className: "album" },
          _react2.default.createElement("img", {
            className: "post-image",
            src: props.post.children.data[0].media_url
          }),
          _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeSolidSvgIcons.faLayerGroup })
        ),
        props.post.media_type === "VIDEO" && _react2.default.createElement(
          "div",
          { className: "video" },
          _react2.default.createElement("img", { className: "post-image", src: props.post.thumbnail_url }),
          _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeSolidSvgIcons.faPlay })
        ),
        !props.post.media_type && _react2.default.createElement("img", { className: "post-image", src: props.defaultImage }),
        _react2.default.createElement(
          "div",
          { className: "overlay", onClick: handleOpenModal },
          _react2.default.createElement(
            "div",
            { className: "action-container" },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeSolidSvgIcons.faHeart }),
              " ",
              " " + props.post.like_count
            ),
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeSolidSvgIcons.faComment }),
              props.post.comments && _react2.default.createElement(
                "p",
                null,
                props.post.comments.data.length
              ),
              !props.post.comments && _react2.default.createElement(
                "p",
                null,
                "0"
              )
            )
          ),
          _react2.default.createElement("div", null),
          _react2.default.createElement(
            "p",
            { className: "overlay-caption" },
            props.post.caption
          )
        )
      ),
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_InstaModal2.default, {
          modalIsOpen: modalIsOpen,
          handleOpenModal: handleOpenModal,
          handleCloseModal: handleCloseModal,
          post: props.post
        })
      )
    )
  );
};

exports.default = SocialInsta;